<template>
    <div>
        <div class="main-header">
            <div class="container">
                <h2 class="main-header-text">Please update your details</h2>
            </div>
        </div>
        <!-- eo main header -->


        <div class="main-section mgt-40">
            <div class="container">

                <div class="main-card">
                    <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
                    <div class="main-card-header">
                        <p>
                            In order to proceed further, we will require you to update the details below.
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-lg-8">
                            <form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
                                <div class="form-card" v-if="IsIdIssueDateUpdatedRequired == 'true'">
                                    <div class="form-card-header">
                                        <h3>ID Details</h3>
                                    </div>

                                    <div class="form-card-forms">

                                        <div class="row">

                                            <div class="col-lg-12">
                                                <div class="form-group">
                                                    <label for="">
                                                        ID Details : {{IdDetail}}
                                                    </label>

                                                </div>
                                            </div>

                                        </div>

                                        <div class="row">

                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="">
                                                        ID Issuing Date
                                                        <span class="required">*</span>
                                                    </label>
                                                    <kendo-datepicker class="form-control" id="IssuedDate"
                                                        name="IssuedDate" v-model="vModel.IssuedDate"
                                                        :format="'dd/MM/yyyy'" :max="minDate" onkeydown="return false;"
                                                        data-vv-as='ID Issue Date' v-validate="'required'"
                                                        :class="{'input': true, 'is-danger': errors.has('IssuedDate') }"
                                                        placeholder="Please Select ID Issuing Date">
                                                    </kendo-datepicker>
                                                    <div v-show="errors.has('IssuedDate')" class="help is-danger">
                                                        {{ errors.first('IssuedDate') }}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    <!-- eo form card forms -->
                                </div>

                                <div class="form-card" v-if="IsProfileUpdatedRequired == 'true'">
                                    <div class="form-card-header">
                                        <h3>Occupation Details</h3>
                                    </div>

                                    <div class="form-card-forms">

                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="">
                                                        Occupation<span class="required">*</span>
                                                    </label>
                                                    <div class="input-group mb-3">
                                                        <kendo-dropdownlist v-if="OccupationCollection != null"
                                                            name='Occupation' v-validate="'required'"
                                                            class="form-control"
                                                            :class="{'input': true, 'is-danger': errors.has('Occupation') }"
                                                            v-model="vModel.OccupationId" :data-text-field="'Text'"
                                                            :data-value-field="'Id'" :auto-bind="true"
                                                            :option-label='"Please Select Occupation"'
                                                            :data-source="OccupationCollection"
                                                            v-on:change='onOccupationChange'>
                                                        </kendo-dropdownlist>
                                                        <div v-show="errors.has('Occupation')" class="help is-danger">
                                                            {{ errors.first('Occupation') }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- eo form group -->
                                        </div>
                                        <!-- eo col -->
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="">
                                                        Sub Occupation
                                                    </label>
                                                    <div class="input-group mb-3">
                                                        <kendo-dropdownlist ref="SubOccupationDropdownList"
                                                            name='SubOccupationId' class="form-control"
                                                            v-validate="(SubOccupationCollection.length > 0 ? 'required' : '')"
                                                            :class="{'input': true, 'is-danger': errors.has('SubOccupationId') }"
                                                            v-model="vModel.SubOccupationId" :data-text-field="'Text'"
                                                            :data-value-field="'Id'" :auto-bind="true"
                                                            data-vv-as='Sub Occupation'
                                                            :option-label='"Please Select Sub Occupation"'
                                                            v-on:change='onSubOccupationChange'>
                                                        </kendo-dropdownlist>
                                                        <div v-show="errors.has('SubOccupationId')"
                                                            class="help is-danger">
                                                            {{ errors.first('SubOccupationId') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- eo form group -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6" v-show="(EmploymentLevelCollection.length > 0)">
                                                <div class="form-group">
                                                    <label for="">
                                                        Employment Level
                                                    </label>
                                                    <div class="input-group mb-3">
                                                        <kendo-dropdownlist ref="EmploymentLevelDownList"
                                                            v-validate="(EmploymentLevelCollection.length > 0 ? 'required' : '')"
                                                            name='EmployeeLevelId' class="form-control"
                                                            :class="{'input': true, 'is-danger': errors.has('EmployeeLevelId') }"
                                                            v-model="vModel.EmployeeLevelId" :data-text-field="'Text'"
                                                            :data-value-field="'Id'" data-vv-as='Employment Level'
                                                            :option-label='"Please Select Employment Level"'>
                                                        </kendo-dropdownlist>
                                                        <div v-show="errors.has('EmployeeLevelId')"
                                                            class="help is-danger">
                                                            {{ errors.first('EmployeeLevelId') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- eo form group -->
                                            </div>
                                        </div>

                                    </div>
                                    <!-- eo form card forms -->
                                </div>
                                <!-- eo form card -->

                                <div class="submit-option">
                                    <div class="left-option">
                                        <button class="btn submit-lefticon-btn" type="button" @click="onLogout">
                                            <span class="left-icon">
                                                <i class="fas fa-angle-left"></i>
                                            </span>
                                            <span class="btn-content">Logout</span>
                                        </button>
                                    </div>

                                    <div class="right-option">
                                        <button class="btn submit-lefticon-btn">
                                            <span class="left-icon">
                                                <i class="fas fa-check"></i>
                                            </span>
                                            <span class="btn-content">Save</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <!-- eo col-8 -->

                        <div class="col-lg-4">
                            <UserDetailSection />
                        </div>
                    </div>
                    <!-- eo row -->

                </div>
                <!-- eo main card -->

            </div>
            <!-- eo container -->
        </div>
        <!-- eo main section -->
    </div>

</template>
<script>
    import Base from "../../shared/Base.vue";
    import commonService from "../../services/common";
    import UserDetailSection from '../../shared/UserDetailSection.vue'

    import ListService from "../../services/list";

    export default {
        name: "UpdateCustomer",
        extends: Base,
        components: { UserDetailSection },
        created() {
            this.IsIdIssueDateUpdatedRequired = commonService.getStorage('IsIdIssueDateUpdatedRequired');
            this.IsProfileUpdatedRequired = commonService.getStorage('IsProfileUpdatedRequired');
            this.IdDetail = commonService.getStorage('IdDetail');
        },
        beforeRouteEnter(to, from, next) {
            
            var promises = [];
            promises.push(ListService.get("list/occupation"));
            Promise.all(promises).then(response => {
                next(p => {
                    p.OccupationCollection = response[0].body;
                });
            });

        },
        methods: {
            onSubmit() {
                var self = this;
                if (self.isProcessing) return;

                self.$validator.validateAll().then(result => {
                    if (result) {
                        var url = 'v2/account/occupation/update';
                        self.isProcessing = true;
                        var cloneModel = Object.assign({}, self.vModel);

                        if(cloneModel.IssuedDate){
                            var issuedDate = commonService.ToYYYYMMDD(
							cloneModel.IssuedDate
                        );
                        cloneModel.IssuedDate = issuedDate;
                        }

                        self.$http.post(url, cloneModel).then(
                            response => {

                                self.$toastr("success", "Updated successfully");
                                self.isProcessing = false;
                                commonService.setStorage("IsProfileUpdatedRequired", "false");
                                commonService.setStorage("IsIdIssueDateUpdatedRequired", "false");
                                if(cloneModel.IssuedDate){
                                    self.updateIdIssueDateOnLocalStorage(cloneModel.IssuedDate);
                                }
                                setTimeout(function () {
                                    self.$router.push("/dashboard");
                                }, 1000);
                            },
                            error => {
                                self.isProcessing = false;
                            }
                        );
                    }
                });
            },
           
            onLogout() {
                commonService.logOut();
            },

            onOccupationChange(e) {
				this.vModel.SubOccupationId = null;
				this.vModel.EmployeeLevelId = null;
				this.SubOccupationCollection = [];
				this.EmploymentLevelCollection = [];


				this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource([]);
				this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmployeeLevelId);
				if (e.sender.value()) {
					this.SubOccupationCollection = e.sender.dataSource.view()[e.sender.selectedIndex - 1].SubOccupations.map(function (m) {
						return {
							Id: m.Id,
							Text: m.Text,
							EmploymentLevel: m.EmployeementLevels
						}
					});
					this.$refs.SubOccupationDropdownList.kendoWidget().setDataSource(this.SubOccupationCollection);

				}
				else {
					this.$refs.SubOccupationDropdownList.kendoWidget().setDataSource([]);
					this.$refs.SubOccupationDropdownList.kendoWidget().value(this.vModel.SubOccupationId);
				}
				
			},
			onSubOccupationChange(e) {

				this.vModel.EmployeeLevelId = null;
				this.EmploymentLevelCollection = [];

				if (e.sender.value()) {
					this.EmploymentLevelCollection = e.sender.dataSource.view()[e.sender.selectedIndex - 1].EmploymentLevel.map(function (m) {
						return {
							Id: m.Id,
							Text: m.Text,
							DefaultValue: m.DefaultValue
						}
					})
					this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource(this.EmploymentLevelCollection);

					if (this.EmploymentLevelCollection.length > 0) {

						var defaultValue = this.EmploymentLevelCollection.filter((s) => { return s.DefaultValue; })[0];
						if (defaultValue) {
							this.vModel.EmployeeLevelId = defaultValue.Id;
							this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmployeeLevelId);
						}

					}
				} else {
					this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource([]);
					this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmployeeLevelId);
				}
            },
            
            updateIdIssueDateOnLocalStorage: function(idIssueDate){
                var userDetailJson = commonService.getUserDetailInformation();
                userDetailJson.IdIssueDate = idIssueDate;
                var userDetailJsonString = JSON.stringify(userDetailJson);
                commonService.setStorage('userDetail',userDetailJsonString);
            }
		
        },
        data() {
            return {
                vModel: {
                    IssuedDate: null,
                    OccupationId: null,
                    SubOccupationId: null,
                    EmployeeLevelId: null,

                },
                BankList: null,                
                IsProfileUpdatedRequired: null,
                IsIdIssueDateUpdatedRequired: null,
                IdDetail: null,
                OccupationCollection: null,
                SubOccupationCollection: [],
                EmploymentLevelCollection: []

            };
        }
    };
</script>